import React from 'react';
import { faqs } from '../mock';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section className="py-20 bg-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Frequently Asked <span className="bg-gradient-to-r from-orange-400 to-orange-600 bg-clip-text text-transparent">Questions</span>
          </h2>
          <p className="text-xl text-gray-400">
            Got questions? We've got answers!
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="bg-zinc-800/50 border border-zinc-700 rounded-xl px-6 hover:border-orange-500 transition-colors duration-300"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <AccordionTrigger className="text-left text-white hover:text-orange-500 font-semibold py-6 text-lg hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-400 leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional Help */}
        <div className="mt-12 text-center bg-zinc-800/50 border border-zinc-700 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-white mb-4">Still have questions?</h3>
          <p className="text-gray-400 mb-6">Feel free to reach out to us directly!</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:9162993189"
              className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold px-8 py-4 rounded-lg transform hover:scale-105 transition-all duration-300 shadow-lg"
            >
              Call (916) 299-3189
            </a>
            <button
              onClick={() => document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center justify-center border-2 border-orange-500 text-white hover:bg-orange-500 hover:text-white font-bold px-8 py-4 rounded-lg transform hover:scale-105 transition-all duration-300"
            >
              Get a Quote
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
